const sendUpdateNumSelectedEvent = () => {
  window.dispatchEvent(new Event('update-num-selected'))
}

export {sendUpdateNumSelectedEvent}
